<app-modal
  #switchRoadOperatorModal
  title="Incidenten historie"
  confirmText="Download"
  (confirmed)="downloadReport()"
  [confirmDisabled]="form.invalid"
  [spinnerOnConfirm]="true"
>
  <div class="modal-body">
    <ndw-alert type="info" class="mb-4"> Incidenten worden maximaal 3 maanden bewaard. </ndw-alert>
    @if (form.errors && form.errors['maxPeriodLength']) {
      <ndw-alert type="critical" class="mb-4">
        Om technische redenen is het niet mogelijk om meer dan {{ maxPeriodLength }} dagen in een
        keer te downloaden.
      </ndw-alert>
    }
    <form [formGroup]="form">
      <div class="flex gap-3">
        <ndw-form-field label="Van" class="flex-1">
          <input ndwInput type="date" formControlName="from" />
        </ndw-form-field>
        <ndw-form-field label="Tot" class="flex-1">
          <input ndwInput type="date" formControlName="to" />
        </ndw-form-field>
      </div>
      @if (form.errors && form.errors['dateBefore']) {
        <span class="text-error mt-1">Startdatum moet voor einddatum liggen.</span>
      }
    </form>
    @if (errorWhileDownloading) {
      <br />
      <span class="text-error"
        >Er is een fout opgetreden tijdens het downloaden van het rapport. Probeer een kortere
        periode of neem contact op met de servicedesk.</span
      >
    }
  </div>
</app-modal>
